export default "__VITE_ASSET__iziNmdnh__"